import './scss/main.scss'

import './ts/product_page';

// Quantity selectors
const quantityContainers = document.querySelectorAll('.quantity:has(input.qty)');
const updateCartButton: HTMLButtonElement|null = document.querySelector('body.woocommerce-cart button[name=update_cart]')

let timeout: any;

quantityContainers.forEach(el => {
    const minus: HTMLButtonElement = el.querySelector('button.minus');
    const plus: HTMLButtonElement = el.querySelector('button.plus');
    const input: HTMLInputElement = el.querySelector('input.qty');

    const triggerChange = () => {
        const event = new Event('change');
        input.dispatchEvent(event);
        
        if (updateCartButton) {
            updateCartButton.disabled = false;
        }
    }

    const step = parseInt(input.step);
    
    minus.onclick = () => {
        // Minimum set to the input's minimum or 0 by default
        const min = parseInt(input.min ? input.min : '0');
        const value = parseInt(input.value) - step;

        input.value = Math.max(min, value).toString();
        triggerChange();
    };

    plus.onclick = () => {
        const value = parseInt(input.value) + step;

        // Maximum set to the input's maximum or the input's value (meaning there is no max)
        const max = parseInt(input.max ? input.max : input.value);

        input.value = (input.max ? Math.min(max, value) : value).toString();
        triggerChange();
    };

    /* if (updateCartButton) {
        // Wait 1s then update the cart if no changes have occured
        input.addEventListener('input', () => {
            if (timeout !== undefined) {
                clearTimeout(timeout);
            }
    
            timeout = setTimeout(() => updateCartButton.click(), 1000);
        });
    } */
});